import { TimeAddons } from './TimeAddons'
import { useTranslate } from '@ur-solutions/react-hooks'
import styled from 'styled-components'
import { TimeOverrides } from './TimeOverrides'
import { FixedAddons } from './FixedAddons'
import { H2 } from '@/components'
import { usePermissions } from '@/utils/hooks'
import { PERMISSIONS } from '@/utils'

const Wrapper = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 1rem 0;

  h2 {
    grid-column: 1 / -1;
    display: flex;
    width: 100%;

    margin: 1rem 0 0 8px;
    font-weight: 600;

    div {
      margin-left: 1rem;
    }

    cursor: default;
  }
`

interface AddonOverviewProps {
  userId: string
  datetimeStart: Date
  datetimeEnd: Date
  onChange?: () => void
}

export const AddonOverview: React.JSX.CFC<AddonOverviewProps> = ({
  userId,
  datetimeStart,
  datetimeEnd,
  onChange,
}) => {
  const translations = useTranslate({
    salaryConfiguration: 'salary.configuration',
    addonsAndChange: 'salary.addons-and-change',
  })
  const { hasPermissions } = usePermissions()
  const canSeeAddons = hasPermissions(PERMISSIONS.salary.view.timeaddon, false)
  const canSeeOverrides = hasPermissions(
    PERMISSIONS.salary.view.timeoverride,
    false
  )
  const canSeeFixedAddons = hasPermissions(
    PERMISSIONS.salary.view.fixedaddon,
    false
  )
  return (
    <Wrapper id="addon-overview">
      <H2>{translations.addonsAndChange}</H2>

      <>
        {canSeeAddons && (
          <TimeAddons
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
            onChange={onChange}
          />
        )}
        {canSeeOverrides && (
          <TimeOverrides
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
            onChange={onChange}
          />
        )}
        {canSeeFixedAddons && (
          <FixedAddons
            datetimeStart={datetimeStart}
            datetimeEnd={datetimeEnd}
            userId={userId}
            onChange={onChange}
          />
        )}
      </>
    </Wrapper>
  )
}
